import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import ChangePassword from '../ChangePassword/ChangePassword.vue';
import ResetPassword from '../ResetPassword/ResetPassword.vue';
import PopupController from '@/assets/ts/controller/PopupController';
import DetalhesQuadroGeral from '@/components/DetalhesQuadroGeral/DetalhesQuadroGeral.vue';
import ConfirmPassword from '../ConfirmPassword/ConfirmPassword.vue';
import DetalhesSolicitacao from '@/components/DetalhesSolicitacao/DetalhesSolicitacao.vue';

@Component({
  name: 'TkPopup',
  components: {
    ChangePassword,
    ResetPassword,
    DetalhesQuadroGeral,
    ConfirmPassword,
    DetalhesSolicitacao,
  },
})
export default class TkPopup extends Vue {
  // [ STORE ]
  @Getter('popUpSize')
  private popUpSize: any;

  @Getter('popUps')
  private popUps: any;

  @Mutation('controlPopUp')
  private controlPopUp: (popUp: {[key: string]: any, popUp: string}) => void;
  // [ STORE ]

  // [ METHODS ]
  private close(popUpName: string, isNotClosePopup = false) {
    if(isNotClosePopup) return;

    PopupController.closePopup(popUpName);
  }
  // [ METHODS ]
}